



function hasShowingChild(children = [],sideBarItems) {
  const showingChildren = children.filter(item => {
    if (item.meta && item.meta.showKey) {
      return sideBarItems.indexOf(item.meta.showKey) > -1
    }
    return !item.hidden;

  })



  // Show parent if there are no child router to display
  if (showingChildren.length > 0) {
    return true
  }

  return false
}


function checkRouterVisible(route,sideBarItems){
  if(!route.meta) return false
  //如果有showKey，则根据showKey进行判断
  if(route.meta.showKey){
    return sideBarItems.indexOf(route.meta.showKey) > -1
  }

  // 没有showKey 根据hidden进行判断。如果hidden隐藏为true，则进行隐藏
  if(route.hidden) return false

  // 如果不隐藏，还要判断有没有要显示的子路由，没有子路由则会进行隐藏
  //如果包含显示的children，那么这个group也会进行显示
  if(route.children){
    return hasShowingChild(route.children, sideBarItems);
  }
  return true
}
// 判断是否hidden
export function setSideBarsVisible(routes, sideBarItems) {
  let tag = "[setSideBarsVisible]"
  routes.forEach(route => {
    // 先对children进行判断
    if (route.children) {
      setSideBarsVisible(route.children, sideBarItems)
    }

    route.hidden = !checkRouterVisible(route,sideBarItems)

  })

  return routes

}



// WEBPACK FOOTER //
// ./src/utils/sideBarUtil.js